<template>
  <div class="joinUs">
    <div class="oneCon">
      <div class="header"></div>
      <div class="content">
        <div class="title">加入我们</div>
        <div class="listCon">
          <div class="list">
            <div class="listTitle">
              <div>
                <img src="../assets/leftIcon.png" alt="">
                生产企业入驻初期优惠政策
              </div>
            </div>
            <div class="content">
              <p><span class="icon"></span>费用减免：初期（1-2年）免收平台保证金，品牌授权使用费打折收取；</p>
              <p><span class="icon"></span>店铺开通时，暂不收取履约保证金，根据后期累计销售金额分3次收取；</p>
              <p><span class="icon"></span>优惠期限：平台运行1-2年后，各项费用恢复正常；</p>
              <p><span class="icon"></span>特别支持：生产企业可在平台上线初期销售自有品牌。</p>
            </div>
            <div class="btnCon">
              <div class="btn" @click="showDialog('6','扫码进行生产企业入驻申请填写')">
                <span>生产企业入驻</span>
                <img src="../assets/addBtn.png" alt="">
              </div>
            </div>
          </div>
          <div class="list">
            <div class="listTitle">
              <div>
                <img src="../assets/leftIcon.png" alt="">
                零售商入驻初期优惠政策
              </div>
            </div>
            <div class="content">
              <p><span class="icon"></span>平台保证金：第一年免收，第二年开始收取；</p>
              <p><span class="icon"></span>平台交易服务费：第1至2年免收，第了至4年减半收取；</p>
              <p><span class="icon"></span>店铺流量：长期提供店铺流量扶持和倾斜；</p>
              <p><span class="icon"></span>店铺排名：长期提供店铺排名靠前的权重；</p>
              <p><span class="icon"></span>金融服务：长期提供优惠的金融服务政策；</p>
            </div>
            <div class="btnCon">
              <div class="btn" @click="showDialog('7','扫码进行店铺入驻申请填写')">
                <span>店铺入驻</span>
                <img src="../assets/addBtn.png" alt="">
              </div>
            </div>
          </div>
          <div class="list">
            <div class="listTitle">
              <div>
                <img src="../assets/leftIcon.png" alt="">
                合伙人奖励政策
              </div>
            </div>
            <div class="content">
              <p><span class="icon"></span>发展生产企业，可获得现金奖励；</p>
              <p><span class="icon"></span>组建A星计划品牌公司，可获得最高2%的股权和现金奖励；</p>
              <p><span class="icon"></span>发展和自营线下服务类店铺和零售实体店铺，可获得长期业务提成和店铺利润。</p>
            </div>
            <div class="btnCon">
              <div class="btn" @click="showDialog('8','扫码进行合伙人入驻申请填写')">
                <span>加入合伙人</span>
                <img src="../assets/addBtn.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="twoCon">
      <div class="widthCon">
         <div class="firstCon">联系我们</div>
      <div class="secondCon">
        <div class="left">
          <div class="line">媒体问询：media@shop-astar.com</div>
          <div class="line">招商合作：bd@shop-astar.com</div>
          <img src="../assets/rightIcon.png" alt="">
        </div>
        <div class="right">
          <div class="line">咨询热线：4008910008</div>
          <div class="line">周一至周五 9:00-12:00 14:00-17:00</div>
          <img src="../assets/rightIcon.png" alt="">
        </div>
      </div>
      <div class="thirdCon">
        <div class="row">
          <div class="left">
            <div class="title">上海总部</div>
            <div class="info">
              <p>地址：民府路578号-尚浦汇T2栋425</p>
              <p>电话：021-5578-2131</p>
            </div>
            <img src="../assets/map1.png" alt="">
          </div>
          <div class="right">
            <div class="title">广州分部</div>
            <div class="info">
              <p>地址：新阳西路38号-生生广场4栋404</p>
              <p>电话：020-3202-5094</p>
            </div>
            <img src="../assets/map2.png" alt="">
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="title">北京分部</div>
            <div class="info">
              <p>地址：北京海淀区中科智汇工厂201D</p>
              <p>电话：4008910008</p>
            </div>
            <img src="../assets/map3.png" alt="">
          </div>
          <div class="right">
            <div class="title">石家庄分部</div>
            <div class="info">
              <p>地址：河北省石家庄市长安区东大街5号开元金融中心13层东区</p>
              <p>电话：4008910008</p>
            </div>
            <img src="../assets/map4.png" alt="">
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="dialogCon" v-if="dialogShow">
      <div class="content">
        <img :src="imgUrl" alt="">
        <p>{{msg}}</p>
      </div>
      <div class="closeBtn">
        <img @click="dialogShow = false" src="../assets/close.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'joinUs',
  data() {
    return {
      imgUrl: '',
      msg: '',
      dialogShow: false,
    }
  },
  methods: {
    showDialog(num, msg) {
      this.imgUrl =  require("../assets/qrcode" + num + ".png");
      this.msg = msg;
      this.dialogShow = true;
    }
  },
  mounted() {
    document.title = "A星计划-加入我们";
  },
}
</script>

<style lang="less" scoped>
.joinUs{
  .oneCon{
    position: relative;
    padding-top: 66px;
    padding-bottom: 86px;
    background: #F9FAFB;
    .header{
      background: linear-gradient(180deg, #DAE6FF 0%, rgba(228, 237, 255, 0) 99%);
      height: 180px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
    .content{
      position: relative;
      z-index: 999;
      .title{
        font-family: Source Han Sans;
        font-size: 30px;
        font-weight: bold;
        line-height: 48px;
        letter-spacing: normal;
        color: #222222;
        text-align: center;
      }
      .listCon{
        width: 1200px;
        margin: 0 auto;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .list:last-child{
          margin-right: 0px!important;
        }
        .list{
          position: relative;
          flex: 1;
          margin-right: 35px;
          border-radius: 10px;
          background: #FFFFFF;
          padding: 44px 26px 80px 38px;
          min-height: 472px;
          box-sizing: border-box;
          .listTitle{
            text-align: center;
            div{
              position: relative;
              font-family: Source Han Sans;
              font-size: 20px;
              font-weight: bold;
              line-height: 26px;
              text-align: center;
              letter-spacing: normal;
              color: #222222;
              display: inline-block;
              img{
                width: 47.5px;
                height: 47.5px;
                position: absolute;
                left: -22px;
                top: -12px;
              }
            }
          }
          .content{
            margin-top: 38px;
            p{
              position: relative;
              font-family: Source Han Sans;
              font-size: 16px;
              font-weight: normal;
              line-height: 26px;
              letter-spacing: normal;
              color: #666666;
              margin-bottom: 10px;
              .icon{
                display: inline-block;
                width: 5px;
                height: 14px;
                border-radius: 1px;
                background: #4A90E2;
                position: absolute;
                left: -10px;
                top: 7px;
              }
            }
          }
          .btnCon{
            position: absolute;
            left: 0;
            width: 100%;
            bottom: 30px;
            display: flex;
            justify-content: center;
            .btn{
              display: flex;
              width: 255.93px;
              height: 50px;
              border-radius: 288px;
              background: #FFFFFF;
              box-sizing: border-box;
              border: 1px solid #4A90E2;
              font-family: Source Han Sans;
              font-size: 16px;
              font-weight: 500;
              line-height: 34px;
              letter-spacing: 0.2em;
              color: #4A90E2;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              img{
                width: 18px;
                height: 18px;
                margin-left: 12px;
              }
            }
          }
        }
      }
    }
  }
  .twoCon{
    padding: 74px 0px 86px 0px;
    background: #FFFFFF;
    .widthCon{
      width: 1200px;
      margin: 0 auto;
    }
    .firstCon{
      font-family: Source Han Sans;
      font-size: 30px;
      font-weight: bold;
      line-height: 48px;
      text-align: center;
      letter-spacing: normal;
      color: #222222;
    }
    .secondCon{
      margin-top: 53px;
      display: flex;
      justify-content: space-around;
      >div{
        position: relative;
      }
      .line{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: normal;
        line-height: 34px;
        letter-spacing: normal;
        color: #222222;
      }
      img{
        width: 47.5px;
        height: 47.5px;
        position: absolute;
        top: -12px;
        left: -22px;
      }
    }
    .thirdCon{
      .row{
        display: flex;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
        margin-top: 72px;
        >div{
          padding: 34px 37px 42px 37px;
          background: #FFFFFF;
          box-sizing: border-box;
          position: relative;
          .title{
            font-family: Source Han Sans;
            font-size: 26px;
            font-weight: bold;
            line-height: 48px;
            text-align: center;
            letter-spacing: normal;
            color: #222222;
          }
          .info{
            margin-top: 19px;
            font-family: Source Han Sans;
            font-size: 16px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: normal;
            color: #222222;
            margin-bottom: 20px;
          }
          img{
            width: 504px;
            height: 344px;
            border-radius: 10px;
          }
        }
        >div::after{
          content: "";
          border-radius: 20px;
          position: absolute;
          left: -50%;
          top: -50%;
          width: 200%;
          height: 200%;
          border: 1px solid #4A90E2;
          scale: 0.5;
        }
      }
    }
  }
  .dialogCon{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .content{
      width: 300px;
      height: 330.6px;
      border-radius: 10px;
      background: #FFFFFF;
      margin: 0 auto;
      img{
        width: 228px;
        height: 228px;
        border-radius: 6px;
        margin-top: 31px;
        margin-left:36px;
      }
      p{
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 44px;
        letter-spacing: normal;
        color: #222222;
        margin-top: 11px;
        text-align: center;
      }
    }
    .closeBtn{
      text-align: center;
      margin-top: 17px;
      cursor: pointer;
      img{
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>